
/* ==========================================================
   CACHE COEUR - QUIZ DE TAILLES
   Version complète FR / EN / IT
   Web Component autonome
   ========================================================== */

(function () {
  "use strict";

  /* ========================================================
     1. DONNEES DES PARCOURS
     ======================================================== */

  const WARNING_I =
    "Nos maillots de bain actuels n'incluent pas encore le bonnet I, mais notre équipe est là pour vous accompagner. Contactez-nous pour explorer ensemble nos autres pièces.";

  const WARNING_J =
    "Nos maillots de bain actuels n'incluent pas encore le bonnet J, mais notre équipe est là pour vous accompagner. Contactez-nous pour explorer ensemble nos autres pièces.";

  const WARNING_GENERAL =
    "Nos maillots de bain actuels n'incluent pas tout à fait votre morphologie, mais notre équipe est là pour vous accompagner et trouver la solution qui vous convient.";

  const WARNING_105D =
    "Votre tour de poitrine correspond à un bonnet 105D que nos maillots de bain actuels n'incluent pas encore. Notre service client se fera un plaisir de vous orienter vers la pièce idéale.";

  const WARNING_I_SPECIAL =
    "Nos maillots de bain actuels n'incluent pas encore le bonnet I, mais notre équipe est là pour vous aider à trouver la pièce qui vous correspond. N'hésitez pas à nous écrire.";

  const q = {};

  q.q1 = {
    type: "choice",
    label: "category",
    choices: [
      { id: "A", label: "bra", next: "q2" },
      { id: "B", label: "briefs", next: "q9" },
      { id: "C", label: "swimwear", next: "q10" },
      { id: "D", label: "tops", next: "q17" },
      { id: "E", label: "trousers", next: "q9" }
    ]
  };

  // Creation des questions de mesures
  function measureQuestion(id, type, ranges) {
    q[id] = {
      type: "range",
      label: type,
      sublabel: type === "underbust"
        ? "underbustHelp"
        : type === "hips"
          ? "hipsHelp"
          : "bustHelp",
      ranges: ranges
    };
  }

  function toRanges(text, values, property = "result") {
    const labels = text.split("|");
    return labels.map((label, index) => ({
      label: label.trim() + " cm",
      [property]: values[index]
    }));
  }

  function braSizes(band, ranges) {
    return toRanges(
      ranges,
      "BCDEFGHIJKL".split("").map(cup => band + cup)
    );
  }

  measureQuestion(
    "q2", "underbust",
    toRanges(
      "69–77|78–86|87–95|96–104|105–113|114–123",
      ["q3", "q4", "q5", "q6", "q7", "q8"],
      "next"
    )
  );

  measureQuestion(
    "q3", "bust",
    braSizes(85,
      "79–81|82–85|86–89|90–94|95–99|100–105|106–112|113–119|120–126|127–133|134–141")
  );

  measureQuestion(
    "q4", "bust",
    braSizes(90,
      "88–90|91–94|95–98|99–103|104–108|109–114|115–121|122–128|129–135|136–142|143–150")
  );

  measureQuestion(
    "q5", "bust",
    braSizes(95,
      "97–99|100–103|104–107|108–112|113–117|118–123|124–130|131–137|138–144|145–151|152–159")
  );

  measureQuestion(
    "q6", "bust",
    braSizes(100,
      "106–108|109–112|113–116|117–121|122–126|127–132|133–139|140–146|147–153|154–160|161–168")
  );

  measureQuestion(
    "q7", "bust",
    braSizes(105,
      "115–117|118–121|122–125|126–130|131–135|136–141|142–148|149–155|156–162|163–169|170–177")
  );

  measureQuestion(
    "q8", "bust",
    braSizes(110,
      "124–126|127–130|131–134|135–139|140–144|145–150|151–157|158–164|165–171|172–178|179–186")
  );

  measureQuestion(
    "q9", "hips",
    toRanges(
      "83–93|94–100|101–107|108–114|115–121|122–128",
      ["XS", "S", "M", "L", "XL", "XXL"]
    )
  );

  measureQuestion(
    "q10", "underbust",
    toRanges(
      "69–77|78–86|87–95|96–104|105–113|114–123",
      ["q11", "q12", "q13", "q14", "q15", "q16"],
      "next"
    )
  );

  // Resultats des maillots de bain
  // Les tailles Monaco sont conservees.

  const swimwearData = {
    q11: {
      ranges: "79–81|82–85|86–89|90–94|95–99|100–105|106–112|113–119|120–127",
      results: [
        "XS",
        "S — bonnet 38C/D",
        "S — bonnet 38C/D",
        "S — bonnet 38E/F",
        "M — bonnet 38E/F",
        "40G/H",
        "40G/H",
        "NON_RECOMMANDE|" + WARNING_I_SPECIAL,
        "NON_RECOMMANDE|" + WARNING_I_SPECIAL
      ]
    },
    q12: {
      ranges: "88–90|91–94|95–98|99–103|104–108|109–114|115–121|122–128|128–136",
      results: [
        "S",
        "M — bonnet 40C/D",
        "M — bonnet 40C/D",
        "M — bonnet 40E/F",
        "L — bonnet 40E/F",
        "40G/H",
        "40G/H",
        "NON_RECOMMANDE|" + WARNING_I,
        "NON_RECOMMANDE|" + WARNING_J
      ]
    },
    q13: {
      ranges: "97–99|100–103|104–107|108–112|113–117|118–123|124–130|131–137|138–145",
      results: [
        "M",
        "L — bonnet 42C/D",
        "L — bonnet 42C/D",
        "L — bonnet 42E/F",
        "XL — bonnet 42E/F",
        "42G/H",
        "42G/H",
        "NON_RECOMMANDE|" + WARNING_I,
        "NON_RECOMMANDE|" + WARNING_J
      ]
    },
    q14: {
      ranges: "106–108|109–112|113–116|117–121|122–126|127–132|133–139|140–146|147–154",
      results: [
        "L",
        "XL — bonnet 44C/D",
        "XL — bonnet 44C/D",
        "XL — bonnet 44E/F",
        "XXL — bonnet 44E/F",
        "44G/H",
        "44G/H",
        "NON_RECOMMANDE|" + WARNING_I,
        "NON_RECOMMANDE|" + WARNING_J
      ]
    },
    q15: {
      ranges: "115–117|118–121|122–125|126–130|131–135|136–141|142–148|149–155|156–162",
      results: [
        "XL",
        "XXL — bonnet 46C/D",
        "NON_RECOMMANDE|" + WARNING_105D,
        "XXL — bonnet 46E/F",
        "46E/F",
        "46G/H",
        "46G/H",
        "NON_RECOMMANDE|" + WARNING_I,
        "NON_RECOMMANDE|" + WARNING_J
      ]
    },
    q16: {
      ranges: "124–126|127–130|131–134|135–139|140–144|145–150|151–157|158–164|165–175",
      results: [
        "XXL",
        "XXL — bonnet 48C/D",
        "XXL — bonnet 48C/D",
        "XXL — bonnet 48E/F",
        "48E/F",
        "NON_RECOMMANDE|" + WARNING_GENERAL,
        "NON_RECOMMANDE|" + WARNING_GENERAL,
        "NON_RECOMMANDE|" + WARNING_I,
        "NON_RECOMMANDE|" + WARNING_J
      ]
    }
  };

  Object.keys(swimwearData).forEach(id => {
    const data = swimwearData[id];
    measureQuestion(
      id,
      "bust",
      toRanges(data.ranges, data.results)
    );
  });

  measureQuestion(
    "q17", "bust",
    toRanges(
      "75–83|84–93|94–102|103–110|111–119|120–128",
      ["XS", "S", "M", "L", "XL", "XXL"]
    )
  );

  /* ========================================================
     2. CORRESPONDANCES SOUTIEN-GORGE / BRASSIERE
     ======================================================== */

  // Cle en taille francaise.
  // Les valeurs XS-XXL ne changent pas avec la langue.

  const BRA_MAP = {
    "85B": "S",  "85C": "S",
    "85D": "S",  "85E": "S",
    "85F": "M",  "85G": "L",

    "90B": "S",  "90C": "S",
    "90D": "M",  "90E": "M",
    "90F": "M",  "90G": "L",

    "95B": "M",  "95C": "M",
    "95D": "M",  "95E": "L",
    "95F": "L",  "95G": "XL",

    "100B": "M", "100C": "L",
    "100D": "L", "100E": "L",
    "100F": "XL", "100G": "XL",

    "105B": "L", "105C": "L",
    "105D": "XL", "105E": "XL",
    "105F": "XL", "105G": "XXL",

    "110B": "XL", "110C": "XL",
    "110D": "XL", "110E": "XL",
    "110F": "XXL", "110G": "XXL"
  };

  /* ========================================================
     3. TRADUCTIONS
     ======================================================== */

  const TEXT = {
    fr: {
      title: "Trouvez votre taille",
      subtitle: "Répondez à 2-3 questions pour connaître votre taille exacte en moins de 30 secondes.",
      start: "Commencer",
      back: "Retour",
      restart: "Recommencer",
      complete: "Terminé",

      category: "Vous souhaitez connaître votre taille de :",
      bra: "Soutien-gorge / Brassière",
      briefs: "Culotte / Shorty",
      swimwear: "Maillot de bain",
      tops: "Sweat / Top / T-shirt",
      trousers: "Jean / Pantalon / Leggings",

      underbust: "Quel est votre tour de sous-poitrine ?",
      underbustHelp: "Mesurez juste sous la poitrine, autour du thorax.",
      bust: "Quel est votre tour de poitrine ?",
      bustHelp: "Mesurez à l'endroit le plus fort de la poitrine.",
      hips: "Quel est votre tour de bassin ?",
      hipsHelp: "Mesurez à l'endroit le plus fort des hanches.",

      recommendation: "Nous vous conseillons comme taille :",
      products: "Voir les produits",
      or: "ou",
      monaco: "(pour le modèle Monaco)",
      monacoOnly: "Disponible uniquement sur le modèle Monaco",
      braSize: "Soutien-gorge",
      braletteSize: "Brassière",

      talk: "Échangeons ensemble",
      contact: "Échanger avec notre équipe",

      warningI: WARNING_I,
      warningJ: WARNING_J,
      warningGeneral: WARNING_GENERAL,
      warning105D: WARNING_105D,
      warningISpecial: WARNING_I_SPECIAL
    },

    en: {
      title: "Find your size",
      subtitle: "Answer 2–3 questions to find your size in under 30 seconds.",
      start: "Get started",
      back: "Back",
      restart: "Start again",
      complete: "Complete",

      category: "What would you like to find your size for?",
      bra: "Bra / Bralette",
      briefs: "Briefs / Boyshorts",
      swimwear: "Swimwear",
      tops: "Sweatshirt / Top / T-shirt",
      trousers: "Jeans / Trousers / Leggings",

      underbust: "What is your underbust measurement?",
      underbustHelp: "Measure around your ribcage, just below your bust.",
      bust: "What is your bust measurement?",
      bustHelp: "Measure around the fullest part of your bust.",
      hips: "What is your hip measurement?",
      hipsHelp: "Measure around the fullest part of your hips.",

      recommendation: "Our recommended size:",
      products: "Shop the collection",
      or: "or",
      monaco: "(for the Monaco style)",
      monacoOnly: "Available only in the Monaco style",
      braSize: "Bra",
      braletteSize: "Bralette",

      talk: "Let's find your fit together",
      contact: "Contact our team",

      warningI: "Our current swimwear collection does not yet accommodate an I cup. Our team is here to help you explore other styles.",
      warningJ: "Our current swimwear collection does not yet accommodate a J cup. Our team is here to help you explore other styles.",
      warningGeneral: "Our current swimwear collection may not fully accommodate your measurements, but our team is here to help you find the right option.",
      warning105D: "Your bust measurement corresponds to a EUR 90D bra size, which is not yet available in our current swimwear collection. Our customer service team would be happy to help you find the right style.",
      warningISpecial: "Our current swimwear collection does not yet accommodate an I cup. Our team would be happy to help you find a suitable style. Please get in touch."
    },

    it: {
      title: "Trova la tua taglia",
      subtitle: "Rispondi a 2–3 domande per trovare la tua taglia in meno di 30 secondi.",
      start: "Inizia",
      back: "Indietro",
      restart: "Ricomincia",
      complete: "Completato",

      category: "Per quale capo desideri trovare la tua taglia?",
      bra: "Reggiseno / Bralette",
      briefs: "Slip / Culotte",
      swimwear: "Costume da bagno",
      tops: "Felpa / Top / T-shirt",
      trousers: "Jeans / Pantaloni / Leggings",

      underbust: "Qual è la tua circonferenza sottoseno?",
      underbustHelp: "Misura la circonferenza del torace appena sotto il seno.",
      bust: "Qual è la tua circonferenza seno?",
      bustHelp: "Misura la circonferenza nel punto più ampio del seno.",
      hips: "Qual è la tua circonferenza fianchi?",
      hipsHelp: "Misura la circonferenza nel punto più ampio dei fianchi.",

      recommendation: "La taglia che ti consigliamo:",
      products: "Scopri i prodotti",
      or: "oppure",
      monaco: "(per il modello Monaco)",
      monacoOnly: "Disponibile solo per il modello Monaco",
      braSize: "Reggiseno",
      braletteSize: "Bralette",

      talk: "Troviamo insieme la taglia giusta",
      contact: "Contatta il nostro team",

      warningI: "La nostra attuale collezione di costumi da bagno non comprende ancora la coppa I. Il nostro team è a tua disposizione per aiutarti a scoprire altri modelli.",
      warningJ: "La nostra attuale collezione di costumi da bagno non comprende ancora la coppa J. Il nostro team è a tua disposizione per aiutarti a scoprire altri modelli.",
      warningGeneral: "La nostra attuale collezione di costumi da bagno potrebbe non essere adatta alle tue misure, ma il nostro team è a disposizione per aiutarti a trovare la soluzione migliore.",
      warning105D: "La tua circonferenza seno corrisponde alla taglia reggiseno EUR 90D, non ancora disponibile nella nostra attuale collezione di costumi da bagno. Il nostro servizio clienti sarà felice di aiutarti.",
      warningISpecial: "La nostra attuale collezione di costumi da bagno non comprende ancora la coppa I. Il nostro team sarà felice di aiutarti a trovare il modello più adatto. Contattaci."
    }
  };

  /* ========================================================
     4. DETECTION DE LA LANGUE SHOPIFY
     ======================================================== */

  function getLanguage(element) {
    const manual = (
      element.dataset.lang ||
      element.dataset.locale ||
      ""
    ).toLowerCase().split(/[-_]/)[0];

    if (TEXT[manual]) return manual;

    // Priorite a la langue de la page Shopify.
    const htmlLang = (
      document.documentElement.lang || ""
    ).toLowerCase().split(/[-_]/)[0];

    if (TEXT[htmlLang]) return htmlLang;

    const path = window.location.pathname.match(
      /^\/(fr|en|it)(?:[-_][a-z]{2})?(?:\/|$)/i
    );

    if (path && TEXT[path[1].toLowerCase()]) {
      return path[1].toLowerCase();
    }

    return "fr";
  }

  /* ========================================================
     5. CONVERSION FR VERS EUR
     ======================================================== */

  function formatBraSize(size, language) {
    if (language === "fr") return size;

    const match = String(size).match(
      /^(\d{2,3})([B-L])$/
    );

    if (!match) return size;

    const frenchBand = Number(match[1]);
    const cup = match[2];

    return "EUR " + (frenchBand - 15) + cup;
  }

  /* ========================================================
     6. STYLES CACHE COEUR
     ======================================================== */

  const CSS = `
    cc-size-quiz {
      display: block;
      font-family: var(--cc-sans, 'Raleway', sans-serif);
      color: var(--cc-ink, #2A1810);
    }

    cc-size-quiz * {
      box-sizing: border-box;
    }

    .cc-quiz__wrap {
      position: relative;
      overflow: hidden;
      min-height: 240px;
    }

    .cc-quiz__intro {
      padding: 32px 0 24px;
    }

    .cc-quiz__intro-title {
      font-family: var(--cc-serif, 'GFS Didot', serif);
      font-size: 26px;
      font-weight: 400;
      color: var(--cc-ink, #2A1810);
      margin: 0 0 12px;
      letter-spacing: 0.03em;
    }

    .cc-quiz__intro-sub {
      font-family: var(--cc-sans, 'Raleway', sans-serif);
      font-size: 13px;
      color: var(--cc-ink-soft, #5C4434);
      margin: 0 0 28px;
      line-height: 1.65;
      max-width: 52ch;
    }

    .cc-quiz__start-btn {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      background: var(--cc-ink, #2A1810);
      color: #fff;
      border: none;
      padding: 14px 28px;
      font-family: var(--cc-sans, 'Raleway', sans-serif);
      font-size: 11px;
      font-weight: 600;
      letter-spacing: 0.18em;
      text-transform: uppercase;
      cursor: pointer;
      border-radius: 0;
      transition: background 0.18s;
    }

    .cc-quiz__start-btn:hover {
      background: var(--cc-accent-deep, #a8814f);
    }

    .cc-quiz__progress {
      margin-bottom: 28px;
      display: flex;
      align-items: center;
      gap: 12px;
    }

    .cc-quiz__progress-bar {
      flex: 1;
      height: 3px;
      background: var(--cc-cream, #f1ebe0);
      position: relative;
      overflow: hidden;
    }

    .cc-quiz__progress-fill {
      position: absolute;
      inset: 0 auto 0 0;
      background: var(--cc-accent, #c69d67);
      transition: width 0.35s ease;
    }

    .cc-quiz__progress-label {
      font-family: var(--cc-sans, 'Raleway', sans-serif);
      font-size: 10px;
      font-weight: 600;
      letter-spacing: 0.18em;
      text-transform: uppercase;
      color: var(--cc-ink-soft, #5C4434);
      white-space: nowrap;
      flex-shrink: 0;
    }

    .cc-quiz__question {
      padding: 4px 0 8px;
    }

    .cc-quiz__q-label {
      font-family: var(--cc-serif, 'GFS Didot', serif);
      font-size: 20px;
      font-weight: 400;
      color: var(--cc-ink, #2A1810);
      margin: 0 0 6px;
      line-height: 1.35;
    }

    .cc-quiz__q-sub {
      font-family: var(--cc-sans, 'Raleway', sans-serif);
      font-size: 12px;
      color: var(--cc-ink-soft, #5C4434);
      margin: 0 0 20px;
      line-height: 1.55;
    }

    .cc-quiz__choices {
      display: flex;
      flex-direction: column;
      gap: 8px;
      margin: 0;
      padding: 0;
      list-style: none;
    }

    .cc-quiz__choice-btn {
      display: block;
      width: 100%;
      text-align: left;
      background: var(--cc-cream, #f1ebe0);
      border: 1px solid transparent;
      padding: 14px 18px;
      font-family: var(--cc-sans, 'Raleway', sans-serif);
      font-size: 13px;
      font-weight: 500;
      color: var(--cc-ink, #2A1810);
      cursor: pointer;
      border-radius: 0;
      transition: background 0.14s, border-color 0.14s, color 0.14s;
    }

    .cc-quiz__choice-btn:hover {
      background: var(--cc-accent, #c69d67);
      color: #fff;
      border-color: var(--cc-accent, #c69d67);
    }

    .cc-quiz__back-btn {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      background: transparent;
      border: none;
      padding: 16px 0 0;
      font-family: var(--cc-sans, 'Raleway', sans-serif);
      font-size: 11px;
      font-weight: 600;
      letter-spacing: 0.12em;
      text-transform: uppercase;
      color: var(--cc-ink-soft, #5C4434);
      cursor: pointer;
    }

    .cc-quiz__result {
      padding: 24px 0 8px;
      text-align: center;
    }

    .cc-quiz__result-label {
      font-family: var(--cc-sans, 'Raleway', sans-serif);
      font-size: 11px;
      font-weight: 600;
      letter-spacing: 0.2em;
      text-transform: uppercase;
      color: var(--cc-ink-soft, #5C4434);
      margin: 0 0 10px;
    }

    .cc-quiz__result-size {
      font-family: var(--cc-serif, 'GFS Didot', serif);
      font-size: 52px;
      font-weight: 400;
      color: var(--cc-accent, #c69d67);
      line-height: 1.15;
      margin: 0 0 24px;
      letter-spacing: 0.04em;
      overflow-wrap: anywhere;
    }

    .cc-quiz__result-sep {
      color: var(--cc-ink-soft, #5C4434);
      font-weight: 300;
      font-size: 0.55em;
      font-family: var(--cc-sans, 'Raleway', sans-serif);
      letter-spacing: 0.15em;
      text-transform: uppercase;
      margin: 0 10px;
      vertical-align: middle;
    }

    .cc-quiz__result-monaco {
      display: inline-flex;
      flex-direction: column;
      align-items: center;
      vertical-align: middle;
      line-height: 1;
    }

    .cc-quiz__result-monaco-size {
      font: inherit;
      color: inherit;
      letter-spacing: inherit;
    }

    .cc-quiz__result-monaco-note {
      font-family: var(--cc-sans, 'Raleway', sans-serif);
      font-size: 13px;
      font-weight: 500;
      font-style: italic;
      letter-spacing: 0.02em;
      color: var(--cc-ink-soft, #5C4434);
      margin-top: 6px;
      white-space: nowrap;
    }

    .cc-quiz__result-note-block {
      font-family: var(--cc-sans, 'Raleway', sans-serif);
      font-size: 12px;
      font-style: italic;
      color: var(--cc-ink-soft, #5C4434);
      margin: -16px 0 24px;
      line-height: 1.5;
    }

    .cc-quiz__result-cta {
      display: inline-block;
      background: var(--cc-ink, #2A1810);
      color: #fff;
      text-decoration: none;
      padding: 14px 28px;
      font-family: var(--cc-sans, 'Raleway', sans-serif);
      font-size: 11px;
      font-weight: 600;
      letter-spacing: 0.18em;
      text-transform: uppercase;
      margin-bottom: 16px;
    }

    .cc-quiz__result-cta:hover {
      background: var(--cc-accent-deep, #a8814f);
      color: #fff;
    }

    .cc-quiz__restart-btn {
      display: block;
      background: transparent;
      border: none;
      padding: 8px 0 0;
      font-family: var(--cc-sans, 'Raleway', sans-serif);
      font-size: 11px;
      font-weight: 600;
      letter-spacing: 0.14em;
      text-transform: uppercase;
      color: var(--cc-ink-soft, #5C4434);
      cursor: pointer;
      text-decoration: underline;
      text-underline-offset: 3px;
      margin: 0 auto;
    }

    .cc-quiz__warning {
      padding: 24px 0 8px;
      text-align: center;
    }

    .cc-quiz__warning-icon {
      font-size: 28px;
      margin-bottom: 12px;
      line-height: 1;
    }

    .cc-quiz__warning-title {
      font-family: var(--cc-serif, 'GFS Didot', serif);
      font-size: 18px;
      font-weight: 400;
      color: var(--cc-ink, #2A1810);
      margin: 0 0 12px;
    }

    .cc-quiz__warning-msg {
      font-family: var(--cc-sans, 'Raleway', sans-serif);
      font-size: 13px;
      color: var(--cc-ink-soft, #5C4434);
      margin: 0 auto 24px;
      line-height: 1.65;
      max-width: 46ch;
    }

    .cc-quiz__warning-link {
      display: inline-block;
      background: transparent;
      border: 1px solid var(--cc-ink, #2A1810);
      color: var(--cc-ink, #2A1810);
      text-decoration: none;
      padding: 13px 26px;
      font-family: var(--cc-sans, 'Raleway', sans-serif);
      font-size: 11px;
      font-weight: 600;
      letter-spacing: 0.18em;
      text-transform: uppercase;
      margin-bottom: 16px;
    }

    .cc-quiz__warning-link:hover {
      background: var(--cc-ink, #2A1810);
      color: #fff;
    }

    .cc-quiz__slide {
      animation-duration: 0.28s;
      animation-timing-function: cubic-bezier(0.22, 0.61, 0.36, 1);
      animation-fill-mode: both;
    }

    @keyframes cc-quiz-slide-in-right {
      from {
        opacity: 0;
        transform: translateX(40px);
      }
      to {
        opacity: 1;
        transform: translateX(0);
      }
    }

    @keyframes cc-quiz-slide-in-left {
      from {
        opacity: 0;
        transform: translateX(-40px);
      }
      to {
        opacity: 1;
        transform: translateX(0);
      }
    }

    .cc-quiz__slide--forward {
      animation-name: cc-quiz-slide-in-right;
    }

    .cc-quiz__slide--back {
      animation-name: cc-quiz-slide-in-left;
    }
  `;

  /* ========================================================
     7. WEB COMPONENT PRINCIPAL
     ======================================================== */

  class CCSizeQuiz extends HTMLElement {

    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;

      this._injectStyles();

      this._language = getLanguage(this);
      this._t = TEXT[this._language];

      this._collectionUrl =
        this.dataset.collectionUrl || "/collections/all";

      this._contactUrl =
        this.dataset.contactUrl || "/pages/contact";

      this._quizTitle =
        this.dataset.quizTitle || this._t.title;

      this._quizSubtitle =
        this.dataset.quizSubtitle || this._t.subtitle;

      this._urls = {
        A: this.dataset.urlSg ||
          "https://cachecoeur.com/collections/lingerie",

        B: this.dataset.urlCulotte ||
          "https://cachecoeur.com/collections/culottes-de-maternite",

        C: this.dataset.urlMaillot ||
          "https://cachecoeur.com/collections/maillots-de-bain",

        D: this.dataset.urlSweat ||
          "https://cachecoeur.com/collections/vetements-grossesse",

        E: this.dataset.urlJean ||
          "https://cachecoeur.com/collections/jeans"
      };

      this._urlMonaco =
        this.dataset.urlMonaco ||
        "https://cachecoeur.com/products/maillot-de-bain-de-grossesse-monaco-emeraude";

      this._state = {
        currentQuestion: null,
        history: []
      };

      this.innerHTML =
        '<div class="cc-quiz__wrap"></div>';

      this._wrap = this.querySelector(
        ".cc-quiz__wrap"
      );

      // Evite la fermeture du drawer Horizon.
      this._wrap.addEventListener(
        "click",
        event => event.stopPropagation()
      );

      this._showIntro();
    }

    _injectStyles() {
      const styleId = "cc-size-quiz-styles";

      if (document.getElementById(styleId)) {
        return;
      }

      const style = document.createElement("style");
      style.id = styleId;
      style.textContent = CSS;
      document.head.appendChild(style);
    }

    _esc(value) {
      return String(value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
    }

    _showIntro() {
      this._state = {
        currentQuestion: null,
        history: []
      };

      this._wrap.innerHTML = `
        <div class="cc-quiz__intro cc-quiz__slide cc-quiz__slide--forward">
          <p class="cc-quiz__intro-title">
            ${this._esc(this._quizTitle)}
          </p>

          <p class="cc-quiz__intro-sub">
            ${this._esc(this._quizSubtitle)}
          </p>

          <button
            type="button"
            class="cc-quiz__start-btn"
            data-action="start"
          >
            ${this._esc(this._t.start)}
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              aria-hidden="true"
            >
              <line x1="5" y1="12" x2="19" y2="12"/>
              <polyline points="12 5 19 12 12 19"/>
            </svg>
          </button>
        </div>
      `;

      const button = this._wrap.querySelector(
        '[data-action="start"]'
      );

      button.addEventListener("click", () => {
        this._renderQuestion("q1", "forward");
      });
    }

    _maxDepth() {
      const first = this._state.history[0];

      if (!first) return 3;

      const chosen = first.chosen;

      if (chosen === "B" || chosen === "D" || chosen === "E") {
        return 2;
      }

      return 3;
    }

    _progressHtml(done = false) {
      const depth = this._state.history.length;
      const maxDepth = this._maxDepth();

      const percentage = done
        ? 100
        : Math.min(
            100,
            Math.round((depth / maxDepth) * 100)
          );

      const stepLabel = done
        ? this._t.complete
        : `${depth + 1} / ${maxDepth + 1}`;

      return `
        <div class="cc-quiz__progress">
          <div class="cc-quiz__progress-bar">
            <div
              class="cc-quiz__progress-fill"
              style="width:${percentage}%"
            ></div>
          </div>

          <span class="cc-quiz__progress-label">
            ${this._esc(stepLabel)}
          </span>
        </div>
      `;
    }

    _renderQuestion(questionId, direction = "forward") {
      const question = q[questionId];

      if (!question) return;

      this._state.currentQuestion = questionId;

      const items = question.type === "choice"
        ? question.choices
        : question.ranges;

      const sublabel = question.sublabel
        ? `<p class="cc-quiz__q-sub">
             ${this._esc(this._t[question.sublabel])}
           </p>`
        : "";

      const choicesHtml = items.map((item, index) => {
        const label = question.type === "choice"
          ? this._t[item.label]
          : item.label;

        return `
          <li>
            <button
              type="button"
              class="cc-quiz__choice-btn"
              data-idx="${index}"
            >
              ${this._esc(label)}
            </button>
          </li>
        `;
      }).join("");

      const backButton = this._state.history.length
        ? `
          <button
            type="button"
            class="cc-quiz__back-btn"
            data-action="back"
          >
            <svg
              width="13"
              height="13"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              aria-hidden="true"
            >
              <line x1="19" y1="12" x2="5" y2="12"/>
              <polyline points="12 19 5 12 12 5"/>
            </svg>
            ${this._esc(this._t.back)}
          </button>
        `
        : "";

      const directionClass = direction === "back"
        ? "cc-quiz__slide--back"
        : "cc-quiz__slide--forward";

      this._wrap.innerHTML = `
        <div class="cc-quiz__question cc-quiz__slide ${directionClass}">
          ${this._progressHtml()}

          <p class="cc-quiz__q-label">
            ${this._esc(this._t[question.label])}
          </p>

          ${sublabel}

          <ul class="cc-quiz__choices">
            ${choicesHtml}
          </ul>

          ${backButton}
        </div>
      `;

      this._wrap.querySelectorAll(
        ".cc-quiz__choice-btn"
      ).forEach(button => {
        button.addEventListener("click", () => {
          const index = Number(button.dataset.idx);

          this._selectChoice(
            items[index],
            questionId
          );
        });
      });

      const back = this._wrap.querySelector(
        '[data-action="back"]'
      );

      if (back) {
        back.addEventListener(
          "click",
          () => this._goBack()
        );
      }
    }

    _selectChoice(item, questionId) {
      const question = q[questionId];

      this._state.history.push({
        questionId: questionId,
        item: item,
        type: question.type,
        chosen: item.id || null
      });

      if (item.result !== undefined) {
        this._showResult(item.result);
      } else if (item.next) {
        this._renderQuestion(item.next, "forward");
      }
    }

    _goBack() {
      this._state.history.pop();

      if (this._state.history.length === 0) {
        this._showIntro();
        return;
      }

      const previous = this._state.history[
        this._state.history.length - 1
      ];

      const targetId = previous.item.next;

      if (targetId && q[targetId]) {
        this._renderQuestion(targetId, "back");
      } else {
        this._renderQuestion("q1", "back");
      }
    }

    _getCategory() {
      const first = this._state.history[0];
      return first ? first.chosen : null;
    }

    _getCollectionUrl(monacoOnly = false) {
      const category = this._getCategory();

      if (category === "C" && monacoOnly) {
        return this._urlMonaco;
      }

      return this._urls[category] ||
        this._collectionUrl;
    }

    _showResult(result) {
      if (
        typeof result === "string" &&
        result.startsWith("NON_RECOMMANDE|")
      ) {
        this._renderNonRecommended(
          result.slice("NON_RECOMMANDE|".length)
        );
        return;
      }

      this._renderResult(result);
    }

    _renderResult(size) {
      const category = this._getCategory();

      let sizeHtml = "";
      let noteHtml = "";
      let monacoOnly = false;

      const comboMatch = String(size).match(
        /^(.+?)\s*—\s*bonnet\s+(.+)$/i
      );

      const monacoMatch =
        /^\d/.test(size) &&
        /[A-Z]\/[A-Z]/.test(size);

      if (category === "C" && comboMatch) {
        const genericSize = comboMatch[1].trim();
        const monacoSize = comboMatch[2].trim();

        sizeHtml = `
          ${this._esc(genericSize)}

          <span class="cc-quiz__result-sep">
            ${this._esc(this._t.or)}
          </span>

          <span class="cc-quiz__result-monaco">
            <span class="cc-quiz__result-monaco-size">
              ${this._esc(monacoSize)}
            </span>

            <span class="cc-quiz__result-monaco-note">
              ${this._esc(this._t.monaco)}
            </span>
          </span>
        `;
      } else if (category === "C" && monacoMatch) {
        monacoOnly = true;

        sizeHtml = this._esc(size);

        noteHtml = `
          <p class="cc-quiz__result-note-block">
            ${this._esc(this._t.monacoOnly)}
          </p>
        `;
      } else if (category === "A") {
        // Les correspondances restent basees
        // sur la taille francaise d'origine.
        const bralette = BRA_MAP[size];

        // Seul l'affichage du soutien-gorge
        // est converti en EUR pour EN et IT.
        const displayedBraSize = formatBraSize(
          size,
          this._language
        );

        if (bralette) {
          sizeHtml = `
            ${this._esc(displayedBraSize)}
            <span class="cc-quiz__result-sep">·</span>
            ${this._esc(bralette)}
          `;
        } else {
          sizeHtml = this._esc(displayedBraSize);
        }
      } else {
        sizeHtml = this._esc(size);
      }

      const url = this._getCollectionUrl(monacoOnly);

      this._wrap.innerHTML = `
        <div class="cc-quiz__result cc-quiz__slide cc-quiz__slide--forward">
          ${this._progressHtml(true)}

          <p class="cc-quiz__result-label">
            ${this._esc(this._t.recommendation)}
          </p>

          <p class="cc-quiz__result-size">
            ${sizeHtml}
          </p>

          ${noteHtml}

          ${url ? `
            <a
              href="${this._esc(url)}"
              class="cc-quiz__result-cta"
            >
              ${this._esc(this._t.products)}
            </a>
          ` : ""}

          <button
            type="button"
            class="cc-quiz__restart-btn"
            data-action="restart"
          >
            ${this._esc(this._t.restart)}
          </button>
        </div>
      `;

      const restart = this._wrap.querySelector(
        '[data-action="restart"]'
      );

      restart.addEventListener(
        "click",
        () => this._showIntro()
      );
    }

    _translateWarning(message) {
      const t = this._t;

      if (message === WARNING_I) {
        return t.warningI;
      }

      if (message === WARNING_J) {
        return t.warningJ;
      }

      if (message === WARNING_GENERAL) {
        return t.warningGeneral;
      }

      if (message === WARNING_105D) {
        return t.warning105D;
      }

      if (message === WARNING_I_SPECIAL) {
        return t.warningISpecial;
      }

      return message;
    }

    _renderNonRecommended(message) {
      const translatedMessage =
        this._translateWarning(message);

      const contact = this._contactUrl;

      this._wrap.innerHTML = `
        <div class="cc-quiz__warning cc-quiz__slide cc-quiz__slide--forward">
          ${this._progressHtml(true)}

          <div
            class="cc-quiz__warning-icon"
            aria-hidden="true"
          >
            ♡
          </div>

          <p class="cc-quiz__warning-title">
            ${this._esc(this._t.talk)}
          </p>

          <p class="cc-quiz__warning-msg">
            ${this._esc(translatedMessage)}
          </p>

          ${contact ? `
            <a
              href="${this._esc(contact)}"
              class="cc-quiz__warning-link"
            >
              ${this._esc(this._t.contact)}
            </a>
          ` : ""}

          <button
            type="button"
            class="cc-quiz__restart-btn"
            data-action="restart"
          >
            ${this._esc(this._t.restart)}
          </button>
        </div>
      `;

      this._wrap.querySelector(
        '[data-action="restart"]'
      ).addEventListener(
        "click",
        () => this._showIntro()
      );
    }
  }

  /* ========================================================
     8. ENREGISTREMENT DU COMPOSANT
     ======================================================== */

  if (!customElements.get("cc-size-quiz")) {
    customElements.define(
      "cc-size-quiz",
      CCSizeQuiz
    );
  }

})();
